import React from "react";
import {motion} from "motion/react";
import TopInfoPanel from "@/components/TopInfoPanel";
import {useNav} from "@/hooks/useNav";
import {r} from "@/utils/responsive";
import {createRelativeClipPath} from "@/utils/svgPathConverter";
import BottomInfoPanel from "@/components/BottomInfoPanel";

interface BottomPanelLayerProps extends React.HTMLAttributes<HTMLDivElement> {
}

const BottomPanelLayer: React.FC<BottomPanelLayerProps> = ({
                                                               className,
                                                               ...props
                                                           }) => {
    const {currentSection} = useNav();
    return (
        <div {...props} style={{
            pointerEvents: 'none',
            userSelect: 'none',
        }}>
            {createRelativeClipPath("M1920 0H1344.13C1299.97 0 1277.9 0 1259.6 10.3121C1259.26 10.5078 1258.91 10.7062 1258.57 10.9071C1240.43 21.4914 1229.29 40.5498 1207 78.6667C1195.86 97.7251 1190.28 107.254 1181.22 112.546C1181.04 112.647 1180.87 112.746 1180.7 112.844C1171.55 118 1160.51 118 1138.44 118H0V130H1920V0Z", 1920, 130, "bottom_panel_mask")}
            {(currentSection !== "screensaver" && currentSection !== "intro_text" && currentSection !== "intro_universe" && currentSection !== "briefing") && (
                <>
                    <motion.div initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                exit={{opacity: 0}}
                                transition={{duration: 0.8, ease: "easeIn"}} style={{
                        zIndex: 11, position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        width: r.vmax(1920),
                        height: r.vmax(130),
                    }}>
                        <BottomInfoPanel/>
                    </motion.div>
                    <motion.div
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        transition={{duration: 0.8, ease: "easeIn"}}
                        style={{
                            position: "fixed",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            willChange: "opacity",
                            transform: "translateZ(0)",
                            zIndex: 10,
                            userSelect: "none",
                            backdropFilter: "blur(74px)",
                            backgroundColor: '#818CD530',
                            width: r.vmax(1920),
                            height: r.vmax(130),
                            clipPath: "url(#bottom_panel_mask)",
                        }}
                    >
                    </motion.div>
                </>
            )}
        </div>
    );
};

export default BottomPanelLayer;
